// Umrlica.js
import React from "react";
import { Container, Row } from "react-bootstrap";

function Reklama({ post }) {
  return (
    <Container
      data-aos="fade-up"
      style={{
        border: "8px groove black",
        backgroundColor: "white",
        maxHeight: "315px",
        height: "100vh",
        marginTop: "25px",
      }}
    >
      <Row>067/068-069</Row>
    </Container>
  );
}

export default Reklama;
